import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "login-container" };
var _hoisted_2 = { class: "login-form" };
import { ref } from "vue";
import { useRouter } from "vue-router";
import api from "@/utils/api";
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup: function (__props) {
        var authKey = ref("");
        var router = useRouter();
        var login = function () {
            api
                .login(authKey.value)
                .then(function (result) {
                console.log(result);
                if (result) {
                    console.log("登录成功");
                    router.push("/");
                }
                else {
                    console.log("登录失败，秘钥错误");
                    window.$message.error("登录失败，秘钥错误");
                }
            })
                .catch(function (err) {
                console.log(err);
                window.$message.error("请求失败");
            });
        };
        return function (_ctx, _cache) {
            var _component_n_input = _resolveComponent("n-input");
            var _component_n_button = _resolveComponent("n-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "login-title" }, "输入秘钥登录", -1)),
                    _createVNode(_component_n_input, {
                        class: "login-input",
                        value: authKey.value,
                        "onUpdate:value": _cache[0] || (_cache[0] = function ($event) { return ((authKey).value = $event); }),
                        type: "text",
                        size: "large",
                        placeholder: "我很神秘"
                    }, null, 8, ["value"]),
                    _createVNode(_component_n_button, {
                        class: "login-btn",
                        type: "primary",
                        size: "large",
                        onClick: login
                    }, {
                        default: _withCtx(function () { return _cache[1] || (_cache[1] = [
                            _createTextVNode("登录")
                        ]); }),
                        _: 1
                    })
                ])
            ]));
        };
    }
});
